import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Fab,
	Typography,
	Icon,
	FormControlLabel,
	Checkbox,
	DialogTitle,
	Table,
	TableRow,
	TableCell,
	TableBody,
	TableHead,
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import AddCircleOutline from '@material-ui/icons/AddCircleOutline'
import DeleteForever from '@material-ui/icons/DeleteForever'
import EditIcon from '@material-ui/icons/Edit'
import { makeStyles } from '@material-ui/styles'
import moment from 'moment'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState, useCallback } from 'react'
import { useCookies } from 'react-cookie'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'
import classNames from 'classnames'
import Form from '../../components/Form/Form'
import { Scrollbars } from 'react-custom-scrollbars'
import HeadTitle from '../../components/HeadTitle/HeadTitle'
import DataTable from '../../components/NewDataTable/NewDataTable'
import { PLATFORM_ID_COOKIE, COMPANY_ID_COOKIE } from '../../constants/cookies'
import ROLES from '../../constants/roles'
import { getExpiredCompanies, copyPdP, deletePdP, pdpList } from '../../containers/DataContainer'
import Access from '../../containers/RoleContainer'
import { COLUMNS_FOLLOW_PDP, getIndexOfColumn } from '../../utils/Datatable'
import api from '../../utils/Requester'
import { bindParams } from '../../utils/Link'
import { PLATFORM_CONFIGURATION_SPECIFIC } from '../../constants/url'

const useStyles = makeStyles((theme) => ({
	content: {
		margin: theme.spacing.unit * 3,
	},
	addPdp: {
		position: 'fixed',
		right: theme.spacing.unit,
		bottom: theme.spacing.unit,
		zIndex: 1,
	},
	icon: {
		'&:hover': {
			cursor: 'pointer',
		},
	},
	dataTableLink: {
		color: theme.palette.secondary.main,
	},
	dataTableContainer: {
		position: 'relative',
	},
	button: {
		position: 'absolute',
		top: 14,
		right: 300,
	},
	IconAndSubText: {},
	ISIcon: {
		display: 'block',
		margin: 'auto',
	},
	ISSubText: {
		textAlign: 'center',
		fontSize: 10,
	},
	mainTitle: {
		color: theme.palette.secondary.main,
		display: 'inline-block',
		width: '100%',
	},
	buttonGroup: {
		display: 'flex',
	},
	modalButton: {
		backgroundColor: theme.palette.primary.main,
		borderColor: theme.palette.secondary.main,
		color: theme.palette.secondary.main,
		borderRadius: 30,
		border: 'solid 2px',
		marginTop: 30,
		padding: 10,
		paddingLeft: 25,
		paddingRight: 25,
		marginBottom: 10,
	},
	dialog: {
		minWidth: 1000,
	},
	paper: {
		margin: 'auto',
		maxWidth: '80%',
		minWidth: 1000,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		outline: 'none',
		padding: 25,
	},
	validateButton: {
		marginLeft: 'auto',
	},
	form: {
		width: '100% !important',
	}
}))


export default function FollowPreventionPlan() {
	const classes = useStyles()
	const { t } = useTranslation('user')
	const [redirect, setRedirect] = useState(false)
	const [cookies] = useCookies()
	const [result, setResult] = useState({ columns: [], data: [], options: {} })
	const [redirectToPdP, setRedirectToPdP] = useState({})
	const [openExpiredCompanies, setOpenExpiredCompanies] = useState(false)
	const [openCopy, setOpenCopy] = useState(false)
	const [openDeletePdP, setOpenDeletePdP] = useState(false)
	const [pdPData, setPdPData] = useState({})
	const { enqueueSnackbar } = useSnackbar()
	const [refresh, setRefresh] = useState(false)
	const [isInExtendedView, setInExtendedView] = useState(false)
	const [canCreateRestrictedPdP, setCanCreateRestrictedPdP] = useState(false)
	const [isLoading, setIsLoading] = useState(true)
	const [expiredCompanies, setExpiredCompanies] = useState([])
	const [nextYear, setNextYear] = useState(false)

	const switchView = () => {
		setInExtendedView(!isInExtendedView)
	}
	const getRestrictedPdPPameter = (platformId) => {
		const translationCode = 'IsPdpRestricted'
		api
			.get(
				bindParams(PLATFORM_CONFIGURATION_SPECIFIC, platformId, translationCode),
			)
			.then(res => {
				const { data, ok, originalError } = res

				if (originalError && originalError.code === 'ECONNABORTED') return
				setCanCreateRestrictedPdP(data.value === '1')
			})
	}

	useEffect(() => {
		getRestrictedPdPPameter(cookies[PLATFORM_ID_COOKIE])

		let body = {
			nbItemsAsked: 10,
			pageNumber: 1,
			includeAll: isInExtendedView,
			companyId: cookies[COMPANY_ID_COOKIE] !== "-1" ? cookies[COMPANY_ID_COOKIE] : null,
		}
		setIsLoading(true)
		pdpList(cookies[PLATFORM_ID_COOKIE], body, function (res, error) {
			if (res) {
				let tempRes = res.data
				// Masquer les colonnes dans le tableau mais les garder dans l'export CSV
				tempRes.columns = tempRes.columns.map((col) => {
					if (col.name === 'rpd_date_reunion_coordination' || col.name === 'rpd_date_inspection_prealable') {
						return { ...col, options: { ...col.options, display: 'false' } }
					}
					return col
				})
				let newColumns = {
					name: 'id',
					label: t('Actions'),
					options: {
						display: 'true',
						filter: false,
						filterOptions: null,
						searchable: false,
						sort: false
					},
				}
				tempRes.columns = [...tempRes.columns, newColumns]
				// Sauvegarder les colonnes et données brutes pour l'export CSV
				const rawColumns = tempRes.columns
				const rawData = tempRes.data
				// Custom onDownload pour construire le CSV à partir des données brutes
				tempRes.options = {
					...tempRes.options,
					onDownload: () => {
						const separator = ';'
						// Colonnes à exporter : toutes sauf Actions (id)
						const exportColumns = rawColumns.filter((col) => col.name !== 'id')
						const exportIndices = exportColumns.map((col) => rawColumns.findIndex((c) => c.name === col.name))
						const dateColumnNames = ['date_debut', 'date_fin', 'date_diffusion', 'date_premiere_diffusion', 'rpd_date_reunion_coordination', 'rpd_date_inspection_prealable']
						// Header
						const header = exportColumns
							.map((col) => '"' + (col.label || col.name).replace(/"/g, '""') + '"')
							.join(separator) + '\r\n'
						// Body : utiliser rawData directement (tableau de tableaux aligné sur rawColumns)
						const body = rawData.map((row) => {
							return exportIndices.map((idx, colIdx) => {
								let value = Array.isArray(row) ? row[idx] : row[exportColumns[colIdx].name]
								if (value && dateColumnNames.includes(exportColumns[colIdx].name)) {
									value = moment(value).format('DD/MM/YYYY')
								}
								if (value === null || value === undefined) value = ''
								return '"' + String(value).replace(/"/g, '""') + '"'
							}).join(separator)
						}).join('\r\n')
						return '\uFEFF' + header + body
					},
				}
				setResult(tempRes)
			}
			setIsLoading(false)
		})
	}, [refresh, isInExtendedView])

	const GetExpiredCompanies = () => {
		getExpiredCompanies(
			cookies[PLATFORM_ID_COOKIE],
			pdPData.pdpId,
			function (res, error) {
				if (res) {
					if (res.data.companyInformations.length === 0) {
						CopyPdP()
						return
					}
					setExpiredCompanies(res.data.companyInformations)
					setOpenExpiredCompanies(true)
				}
			})
	}

	const CopyPdP = () => {
		copyPdP(
			cookies[PLATFORM_ID_COOKIE],
			pdPData.pdpId,
			pdPData.revisionNumber,
			nextYear,
			function (res, error) {
				if (res) {
					setRedirectToPdP({
						isTrue: true,
						pdpId: res.data.pdPId,
						revisionNumber: res.data.revisionNumber,
					})
				}
				if (error) {
					enqueueSnackbar(t('error') + ':' + error.status, { variant: 'error' })
				}
			},
		)
	}

	const DeletePdP = () => {
		deletePdP(cookies[PLATFORM_ID_COOKIE], pdPData.pdpId, function (res, error) {
			if (res) {
				enqueueSnackbar(t('ThePdPHasBeenDeleted'), { variant: 'info' })
				setRefresh(!refresh)
				setOpenDeletePdP(false)
			}
			if (error) {
				enqueueSnackbar(t('error') + ':' + error.status, { variant: 'error' })
			}
		})
	}

	const IDWP = {
		AUTO: {
			id: 'Received',
			label: t('user:Receive'),
			icon: 'checked_circle',
			color: '#006946',
		},
		ERROR: {
			id: 'Failed',
			label: t('user:ErrorSend'),
			icon: 'error',
			color: '#F44436',
		},
	}

	const IconWithSubtext = ({ icon, label, color }) => {
		return (
			<div className={classes.IconAndSubText}>
				<Icon className={classes.ISIcon} style={{ color: color }}>
					{icon}
				</Icon>
				<Typography className={classes.ISSubText} style={{ color: color }}>
					{label}
				</Typography>
			</div>
		)
	}

	const findIDWPById = (id) =>
		Object.values(IDWP).filter((s) => {
			if (s.id === id) return s
		})[0]

	const handleNextYearChange = useCallback((e) => {
		setNextYear(e.target.checked)
	}, [])

	const executeOnClose = useCallback(() => {
		setOpenExpiredCompanies(false)
		setOpenCopy(false)
	})

	const ModalExpiredCompanies = () => (
		<Dialog open={openExpiredCompanies} onClose={executeOnClose} classes={{ paper: classes.dialog }}>
			<div className={classes.paper}>
				<Form onSubmit={CopyPdP} className={classes.form}>
					<Typography variant="h6" classes={{ root: classes.mainTitle }}>
						<div>{t('copyWarning')}</div>
						<div>{t('doYouWantToContinue')}</div>
					</Typography>
					<Scrollbars autoHeight={true} autoHeightMin={'50vh'}>
						<Table className={classes.table}>
							<TableHead>
								<TableRow>
									<TableCell>{t('companyName')}</TableCell>
									<TableCell>{t('Agency')}</TableCell>
									<TableCell>{t('socialReason')}</TableCell>
									<TableCell>{t('siretNumber')}</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{expiredCompanies && expiredCompanies.map(company => (
									<TableRow key={company.siretNumber}>
										<TableCell component="th" scope="row">
											{company.entNom}
										</TableCell>
										<TableCell>{company.entNomAgence}</TableCell>
										<TableCell>{company.entRaisonSociale}</TableCell>
										<TableCell>{company.entNumeroSiret}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</Scrollbars>
					<div className={classes.buttonGroup}>
						<Button classes={{ root: classes.modalButton }} onClick={executeOnClose}>
							{t('cancel')}
						</Button>
						<Button className={classNames(classes.modalButton, classes.validateButton)} type="submit">
							{t('submit')}
						</Button>
					</div>
					<div></div>
				</Form>
			</div>
		</Dialog >
	)

	const CopyPdpPopup = useCallback(() => (
		<Dialog open={openCopy} onClose={() => setOpenCopy(false)}>
			<DialogContent>
				<Typography variant="subtitle1">{t('SureToCreatePdP')}</Typography>
				<FormControlLabel
					control={
						<Checkbox
							checked={nextYear}
							onChange={handleNextYearChange}
							color="secondary"
						/>
					}
					label={t('CopyToNextYear')}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setOpenCopy(false)} color="secondary">
					{t('cancel')}
				</Button>
				<Button
					onClick={() => {
						GetExpiredCompanies()
					}}
					color="secondary"
				>
					{t('confirm')}
				</Button>
			</DialogActions>
		</Dialog>
	), [openCopy, nextYear, handleNextYearChange, t])

	const DeletePdpPopup = () => (
		<Dialog open={openDeletePdP} onClose={() => setOpenDeletePdP(false)}>
			<DialogContent>
				<Typography variant="subtitle1">{t('SureToDeletePdP')}</Typography>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setOpenDeletePdP(false)} color="secondary">
					{t('cancel')}
				</Button>
				<Button
					onClick={() => {
						DeletePdP()
					}}
					color="secondary"
				>
					{t('confirm')}
				</Button>
			</DialogActions>
		</Dialog>
	)

	return (
		<>
			{redirect && <Redirect to={'/preventionPlan'} />}
			{redirectToPdP.isTrue && (
				<Redirect
					to={'/preventionPlan/' + redirectToPdP.pdpId + '/' + redirectToPdP.revisionNumber}
				/>
			)}
			{CopyPdpPopup()}
			<DeletePdpPopup />
			<ModalExpiredCompanies />
			<div className={classes.content}>
				<HeadTitle title={t('FollowPdP')} link="/dashboard" />
				<br />
				<div className={classes.dataTableContainer}>
					<Access
						accept={[
							ROLES.PLATFORMMANAGER,
							ROLES.ADMIN,
							ROLES.EXTCOMP,
							ROLES.EXTCOMPADMIN,
							ROLES.PRINCIPAL,
						]}
					>
						<Button
							variant="contained"
							color="primary"
							className={classes.button}
							onClick={() => switchView()}
						>
							{isInExtendedView ? t('completeView') : t('limitedView')}
						</Button>
					</Access>
					<DataTable
						title={t('FollowPdP')}
						data={result.data}
						columns={result.columns}
						options={result.options}
						isLoading={isLoading}
						customColumns={[
							{
								name: 'date_debut',
								component: (value, tableMeta, updateValue) => moment(value).format('DD/MM/YYYY'),
							},
							{
								name: 'date_fin',
								component: (value, tableMeta, updateValue) => moment(value).format('DD/MM/YYYY'),
							},
							{
								name: 'date_diffusion',
								component: (value, tableMeta, updateValue) => {
									if (value) return moment(value).format('DD/MM/YYYY')
								},
							},
							{
								name: 'date_premiere_diffusion',
								component: (value, tableMeta, updateValue) => {
									if (value) return moment(value).format('DD/MM/YYYY')
								},
							},
							{
								name: 'rpd_date_reunion_coordination',
								component: (value, tableMeta, updateValue) => {
									if (value) return moment(value).format('DD/MM/YYYY')
								},
							},
							{
								name: 'rpd_date_inspection_prealable',
								component: (value, tableMeta, updateValue) => {
									if (value) return moment(value).format('DD/MM/YYYY')
								},
							},
							{
								name: 'dwpStatusCode',
								component: (value, tableMeta, updateValue) => {
									if (!value) return
									let currentState = findIDWPById(value)
									if (!currentState) return
									return (
										<IconWithSubtext
											icon={currentState.icon}
											label={currentState.label}
											color={currentState.color}
										/>
									)
								},
							},
							{
								name: 'id',
								component: (_value, tableMeta) => {
									const numeroFormat =
										tableMeta.rowData[
										getIndexOfColumn(result.columns, COLUMNS_FOLLOW_PDP.NUMERO_FORMAT)
										]
									const pdpId =
										tableMeta.rowData[getIndexOfColumn(result.columns, COLUMNS_FOLLOW_PDP.ID)]
									const pdpStatus =
										tableMeta.rowData[getIndexOfColumn(result.columns, COLUMNS_FOLLOW_PDP.STATUS)]

									let pdpInfos = {
										pdpId: pdpId,
										revisionNumber: numeroFormat ?? 0,
									}
									return (
										<>
											<a
												href={'/preventionPlan/' + pdpInfos.pdpId + '/' + pdpInfos.revisionNumber}
												alt="pdp"
												className={classes.dataTableLink}
											>
												<EditIcon className={classes.icon} />
											</a>
											{pdpStatus === 'Brouillon' && (
												<Access accept={[ROLES.ADMIN, ROLES.PLATFORMMANAGER]}>
													<DeleteForever
														color="secondary"
														className={classes.icon}
														onClick={() => {
															setOpenDeletePdP(true)
															setPdPData({
																pdpId: pdpId,
																revisionNumber: numeroFormat ?? 0,
															})
														}}
													></DeleteForever>
												</Access>
											)}
											<Access accept={[ROLES.ADMIN, ROLES.PLATFORMMANAGER]}>
												<AddCircleOutline
													color="secondary"
													className={classes.icon}
													onClick={() => {
														setOpenCopy(true)
														setNextYear(false) // Réinitialiser la checkbox à chaque ouverture
														setPdPData({
															pdpId: pdpId,
															revisionNumber: numeroFormat ?? 0,
														})
													}}
												></AddCircleOutline>
											</Access>
										</>
									)
								},
							},
						]}
						customLabels={[
							{
								name: 'numero_pdp',
								label: t('numero_pdp'),
							},
							{
								name: 'status',
								label: t('status'),
							},
							{
								name: 'numero_format',
								label: t('numero_format'),
							},
							{
								name: 'label',
								label: t('label'),
							},
							{
								name: 'works_locations',
								label: t('works_locations'),
							},
							{
								name: 'date_debut',
								label: t('date_debut'),
							},
							{
								name: 'date_fin',
								label: t('date_fin'),
							},
							{
								name: 'date_diffusion',
								label: t('date_diffusion'),
							},
							{
								name: 'date_premiere_diffusion',
								label: t('date_premiere_diffusion'),
							},
							{
								name: 'rpd_date_reunion_coordination',
								label: t('rpd_date_reunion_coordination'),
							},
							{
								name: 'rpd_date_inspection_prealable',
								label: t('rpd_date_inspection_prealable'),
							},
							{
								name: 'dwpStatusCode',
								label: t('dwpstatuscode'),
							},
							{
								name: 'dwpStatusLabel',
								label: t('dwpstatuscode'),
							},
							{
								name: 'action',
								label: t('Action'),
							},
						]}
					/>
				</div>

				{canCreateRestrictedPdP && (
					<Access accept={[ROLES.ADMIN, ROLES.PLATFORMMANAGER, ROLES.PRINCIPAL]}>
						<Fab
							color="secondary"
							aria-label="add"
							className={classes.addPdp}
							onClick={() => {
								setRedirect(true)
							}}
						>
							<AddIcon />
						</Fab>
					</Access>
				)}

				{!canCreateRestrictedPdP && (
					<Access accept={[ROLES.ADMIN, ROLES.PLATFORMMANAGER]}>
						<Fab
							color="secondary"
							aria-label="add"
							className={classes.addPdp}
							onClick={() => {
								setRedirect(true)
							}}
						>
							<AddIcon />
						</Fab>
					</Access>
				)}
			</div>
		</>
	)
}
